import { IBodyDisplayUnits } from "features/profile/profileTypes"
import { roundByDecimalPlace } from "utils"

const ML_PER_OZ = 29.5735
const OZ_DECIMAL_PLACE = 1

// Maximum water intake limit
export const MAX_WATER_INTAKE_ML = 10000
export const MAX_WATER_INTAKE_OZ = 338

// Predefined bottle sizes
export const WATER_PRESETS_ML = [250, 500, 750, 1000] as const
export const WATER_PRESETS_OZ = [8, 16, 24, 32] as const

export type WaterPresetMl = (typeof WATER_PRESETS_ML)[number]
export type WaterPresetOz = (typeof WATER_PRESETS_OZ)[number]

export const getWaterPresets = (bodyDisplayUnits: IBodyDisplayUnits) => {
  return bodyDisplayUnits === "IMPERIAL" ? WATER_PRESETS_OZ : WATER_PRESETS_ML
}

export const mlToOz = (ml: number) => {
  return roundByDecimalPlace(ml / ML_PER_OZ, OZ_DECIMAL_PLACE)
}

export const ozToMl = (oz: number) => {
  return Math.round(oz * ML_PER_OZ)
}

export const getMaxWaterIntake = (unit: "ml" | "oz") =>
  unit === "oz" ? MAX_WATER_INTAKE_OZ : MAX_WATER_INTAKE_ML

export const getDisplayWaterVolume = (
  bodyDisplayUnits: IBodyDisplayUnits,
  mlValue: number,
) => {
  return bodyDisplayUnits === "IMPERIAL" ? mlToOz(mlValue) : mlValue
}

export const getWaterUnit = (bodyDisplayUnits: IBodyDisplayUnits) => {
  return bodyDisplayUnits === "IMPERIAL" ? "oz" : "ml"
}

// Convert display value to ml for server
export const getWaterVolumeInMl = (
  bodyDisplayUnits: IBodyDisplayUnits,
  displayValue: number,
) => {
  return bodyDisplayUnits === "IMPERIAL" ? ozToMl(displayValue) : displayValue
}
